import { deliveryFeeConstants } from "../../constants";
import { deliveryFeeService } from "../../services";
import { alertActions } from "../alert.actions";

export const deliveyFeeActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    deliveryFeeService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: deliveryFeeConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: deliveryFeeConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: deliveryFeeConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    deliveryFeeService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: deliveryFeeConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: deliveryFeeConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: deliveryFeeConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    deliveryFeeService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: deliveryFeeConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: deliveryFeeConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: deliveryFeeConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    deliveryFeeService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: deliveryFeeConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: deliveryFeeConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: deliveryFeeConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: deliveryFeeConstants.CLEAR };
}
